import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Identity = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M19.009 4.668c-5.61-.89-8.42-.89-14.03 0-.96.15-2.01 1.1-2.24 2.07-.98 4.21-.99 6.31 0 10.52.23.96 1.26 1.91 2.24 2.07 5.61.89 8.42.89 14.03 0 .96-.16 2.01-1.1 2.24-2.07.99-4.21.99-6.31 0-10.52-.23-.96-1.27-1.92-2.24-2.07Zm-10.16 3.43c1.1-.04 1.9.8 1.89 1.93 0 1.13-.85 1.97-1.98 1.97s-1.98-.82-1.93-1.91c.03-1.11.92-1.96 2.02-1.99Zm3.56 7.38c0 .25-.2.46-.45.46-2.49 0-3.74-.04-6.23-.18a.542.542 0 0 1-.49-.46c-.11-1.27 1.52-2.57 3.52-2.56 2.01 0 3.66 1.39 3.65 2.74Zm6.44-5.35c.03.52-.4.93-.95.92-1.18-.02-1.77-.02-2.95-.03-.54 0-.99-.45-.99-.99-.01-.54.42-.97.96-.96 1.17.03 1.74.04 2.91.09.53.02 1 .46 1.02.97Zm-1.25 2.72a1.071 1.071 0 0 1 0 2.14 1.071 1.071 0 0 1 0-2.14Z"
      fill="currentColor"
    />
  </Icon>
);

export default Identity;
